const Contact = {

	init: function() {

		if($('.entry').get(0)) {
			return;
		}

		this.API = '/assets/php/ja/contact/';
		this.view = {};
		this.view.form = $('.contact-form').closest('form');
		this.view.loader = $('.ajax-loader');
		this.view.submitButton = this.view.form.find('.js-form-submit');

		$(document).on('click', '.js-form-submit', () => {
			this.send(true);
		});
		this.send(false);
	},
	send: function(loading) {
		$.ajax(this.API, {
			type : 'post',
			data :  this.view.form.serialize(),
			timeout: 10000,
		}).done((response) => {
			this.view.form.html($('<div>').append(response).html());
			this.view.loader.removeClass('is-active');
		}).fail((response) => {
			this.view.loader.removeClass('is-active');
		});
		if(loading) {
			this.view.loader.addClass('is-active');
		}
	}
}

export default Contact;
